<admin-header [primaryButtons]="headerPrimaryButtons" [title]="title" (eventFired)="headerButtonClick($event)"></admin-header>
<div class="form-container">
	<dx-form class="m-3" [(formData)]="item.value" [showColonAfterLabel]="true" labelLocation="top" [colCount]="2" [readOnly]="readOnly">
		<dxi-column *ngFor="let property of getKeys(item.value)" dataField="Region" dataType="string"></dxi-column>
	</dx-form>
</div>